import { types } from "../actions/type";
const initialState = {
    loading: false,
    message: '',
    showMessage: false,
    buyerSupplierData:null,
    redirect: '',
    token: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.AUTHENTICATED:
        return {
            ...state,
            loading: false,
            redirect: '/buyer',
            token: action.token
        }
  case types.BUYER_SUPPLIER_DATA:
    return{
      ...state,
      loading:false,
      buyerSupplierData:action.data
    }
  
        case types.SHOW_AUTH_MESSAGE:
          return {
              ...state,
              message:action.message,
              showMessage:action.showMessage
          }
        case types.SHOW_AUTH_LOADING: 
			return {
				...state,
				loading: action.loading
			}
    default:
      return state;
  }
};